import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import qs from 'qs'
Vue.use(Vuex)
const state = {
  headerDetails: [],
}

const mutations = {
  SET_HEADER_DETAILS(state, headerData) {
    state.headerDetails = headerData.message;
  },

  CLEAR_LAYOUT_STATE(state) {
    state.headerDetails = [];
  },
  SOCKET_RAISETICKETNOTIFICATION(state, data) {
    console.log("rase", data);
  },
  SOCKET_UNASSIGNEDTASKNOTIFY(state, data) {
    console.log("enter unnassin");
    var data = JSON.parse(data);
    if (state.headerDetails.unassignedTaskCount != data.unassignedTaskCount && data.roomId == state.headerDetails.Auth.User.id + "-header") {
      if (state.headerDetails.unassignedTaskCount != 0) {
        Vue.set(state.headerDetails, "unassignedTaskCount", data.unassignedTaskCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      } else if (state.headerDetails.unassignedTaskCount == 0) {
        Vue.set(state.headerDetails, "unassignedTaskCount", data.unassignedTaskCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      }
      if (window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission(function (status) { // status is "granted", if accepted by user
          var n = new Notification('Unclaimed Task', {
            body: data.unassignedTaskCount + ' unclaimed task(s) are pending.',
            icon: "", // optional
            iconUrl: ""
          });
          n.onclick = function () {
            window.open('/tasks');
          };
          n.close();
        });
      } else {
        Notification.requestPermission();
      }
    }
  },
  SOCKET_UNREADMESSAGENOTIFY(state, data) {
    var data = JSON.parse(data);
    if (state.headerDetails.unReadMessageCount != data.unReadMessageCount && data.roomId == state.headerDetails.Auth.User.id + "-header") {
      if (state.headerDetails.unReadMessageCount != 0) {
        Vue.set(state.headerDetails, "unReadMessageCount", data.unReadMessageCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      } else if (state.headerDetails.unassignedTaskCount == 0) {
        Vue.set(state.headerDetails, "unReadMessageCount", data.unReadMessageCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      }
      if (window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission(function (status) { // status is "granted", if accepted by user
          var n = new Notification('Unread Messages', {
            body: data.unReadMessageCount+ ' messages are unread',
            icon: "", // optional
            iconUrl: ""
          });
          n.onclick = function () {
            window.open('/helpdesk/tickets');
          };
          n.close();
        });
      } else {
        Notification.requestPermission();
      }
    }
  },
  SOCKET_ASSIGNEDTASKNOTIFY(state, data) {
    var data = JSON.parse(data);
    if (state.headerDetails.assignedTaskCount != data.assignedTaskCount && data.roomId == state.headerDetails.Auth.User.id + "-header") {
      if (state.headerDetails.assignedTaskCount != 0) {
        Vue.set(state.headerDetails, "unassignedTaskCount", data.assignedTaskCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      } else if (state.headerDetails.assignedTaskCount == 0) {
        Vue.set(state.headerDetails, "unassignedTaskCount", data.assignedTaskCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      }
      if (window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission(function (status) { // status is "granted", if accepted by user
          var n = new Notification('Assigned Task', {
            body: data.assignedTaskCount + ' assigned task(s) are pending.',
            icon: "", // optional
            iconUrl: ""
          });
          n.onclick = function () {
            window.open('/tasks/assigned_tasks');
          };
          n.close();
        });
      } else {
        Notification.requestPermission();
      }
    }
  },
  SOCKET_RAISETICKETNOTIFICATION(state, data) {
    var data = JSON.parse(data);
    if (state.headerDetails.ticketsCount != data.raiseTicketCount && data.roomId == state.headerDetails.Auth.User.id + "-header") {
      if (state.headerDetails.ticketsCount != 0) {
        Vue.set(state.headerDetails, "ticketsCount", data.raiseTicketCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      } else if (state.headerDetails.ticketsCount == 0) {
        Vue.set(state.headerDetails, "ticketsCount", data.raiseTicketCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      }
      if (window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission(function (status) { // status is "granted", if accepted by user
          var n = new Notification('Ticket', {
            body: data.raiseTicketCount + ' ticket(s) have been raised.',
            icon: "", // optional
            iconUrl: ""
          });
          n.onclick = function () {
            window.open('/helpdesk');
          };
          n.close();
        });
      } else {
        Notification.requestPermission();
      }
    }
  },
  SOCKET_USERPENDINGNOTIFY(state, data) {
    var data = JSON.parse(data);
    if (state.headerDetails.usersPendingNotify != data.userPendingCount && data.roomId == state.headerDetails.Auth.User.id + "-header") {
      if (state.headerDetails.usersPendingNotify != 0) {
        Vue.set(state.headerDetails, "usersPendingNotify", data.userPendingCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      } else if (state.headerDetails.usersPendingNotify == 0) {
        Vue.set(state.headerDetails, "usersPendingNotify", data.userPendingCount)
        Vue.set(state.headerDetails, "notificationCount", data.notificationCount)
      }
      if (window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission(function (status) { // status is "granted", if accepted by user
          var n = new Notification('User Pending Approval', {
            body: data.userPendingCount + ' user(s) have requested access.',
            icon: "", // optional
            iconUrl: ""
          });
          n.onclick = function () {
            window.open('/users/pending_users');
          };
          n.close();
        });
      } else {
        Notification.requestPermission();
      }
    }
  },
  SOCKET_NATLOGFAILURES(state, data) {
    var data = JSON.parse(data);
    if (state.headerDetails.natLogFailureRouters != data.natLogFailureRouters && data.roomId == state.headerDetails.Auth.User.id + "-header") {
      if(state.headerDetails.natLogFailureRouters == ""){
        Vue.set(state.headerDetails, "natLogFailureRouters", data.failureRouters)
        Vue.set(state.headerDetails, "notificationCount", state.headerDetails.notificationCount + data.notifycount)
      } else {
        Vue.set(state.headerDetails, "natLogFailureRouters", data.failureRouters)
      }
      if (window.Notification && Notification.permission !== "denied") {
        Notification.requestPermission(function (status) { // status is "granted", if accepted by user
          var n = new Notification('Nat Log stopped', {
            body: 'Nat Logs have stopped generating for ' + data.failureRouters + ' router(s).',
            icon: "", // optional
            iconUrl: ""
          });
          n.onclick = function () {
            window.open('/routers');
          };
          n.close();
        });
      } else {
        Notification.requestPermission();
      }
    }
  },
}

const actions = {
  fetchHeaderDetails({
    commit
  }, authData) {
    //Nprogress.start()
    axios.get("/dashboard/jaze_header")
      .then(response => {
        //Nprogress.done()
        localStorage.removeItem('socEnable')
        localStorage.removeItem('socAdmin')
        localStorage.setItem('socAdmin', response.data.message.Auth.User.id);
        var socEnable = response.data.message.nodejsenabled
        localStorage.setItem('socEnable', socEnable.toString());
        if (localStorage.getItem("socketConnected") != "yes") {
          const event = new Event('build');
          window.dispatchEvent(event);
        }
        commit('SET_HEADER_DETAILS', response.data)

      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            router.push("/signin");
          }
        }
      })
  },

  clearLayoutState({
    commit,
    dispatch
  }) {
    commit('CLEAR_LAYOUT_STATE')
  },

}

const getters = {
  headerDetailsGetter: state => {
    return state.headerDetails;
  }

}

export default {
  state,
  mutations,
  actions,
  getters
}
